<template>
	<ul class="lightrope">
		<li
				v-for="n in currentBulbsCount"
				:key="n"
		></li>
	</ul>
</template>

<script>
export default {
	name: 'ChristmasLightrope',
	props: {
		// сколько лампочек на десктопе
		bulbsDesktop: {
			type: Number,
			default: 42
		},
		// сколько лампочек на мобильных
		bulbsMobile: {
			type: Number,
			default: 24
		},
		// ширина, ниже которой считаем устройство мобильным
		mobileBreakpoint: {
			type: Number,
			default: 768
		}
	},
	data() {
		return {
			isMobile: false
		};
	},
	computed: {
		currentBulbsCount() {
			return this.isMobile ? this.bulbsMobile : this.bulbsDesktop;
		}
	},
	mounted() {
		this.checkIsMobile();
		window.addEventListener('resize', this.checkIsMobile);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.checkIsMobile);
	},
	methods: {
		checkIsMobile() {
			if (typeof window === 'undefined') return;
			this.isMobile = window.innerWidth <= this.mobileBreakpoint;
		}
	}
};
</script>

<style lang="scss" scoped>
$globe-width:   12px;
$globe-height:  28px;
$globe-spacing: 40px;
$globe-spread:  3px;
$light-off-opacity: 0.4;

// цвета лампочек
$color-1: #6cc084; // зелёный
$color-2: #ebcb5e; // жёлтый
$color-3: #d96178; // розовый/красный

.lightrope {
	text-align: center;
	white-space: nowrap;
	overflow: hidden;
	position: absolute;
	z-index: 1;
	margin: -15px 0 0 0;
	padding: 0;
	pointer-events: none;
	width: 100%;

	li {
		position: relative;
		list-style: none;
		padding: 0;
		display: inline-block;
		width: $globe-width;
		height: $globe-height;
		border-radius: 50%;
		margin: $globe-spacing / 2;

		animation-fill-mode: both;
		animation-iteration-count: infinite;
		animation-name: flash-1;
		animation-duration: 2s;

		background: $color-1;
		box-shadow: 0 $globe-height/6 $globe-width*2 $globe-spread $color-1;

		&:nth-child(2n + 1) {
			background: $color-2;
			box-shadow: 0 $globe-height/6 $globe-width*2 $globe-spread $color-2;
			animation-name: flash-2;
			animation-duration: 0.4s;
		}

		&:nth-child(4n + 2) {
			background: $color-3;
			box-shadow: 0 $globe-height/6 $globe-width*2 $globe-spread $color-3;
			animation-name: flash-3;
			animation-duration: 1.1s;
		}

		&:nth-child(odd) {
			animation-duration: 1.8s;
		}

		&:nth-child(3n + 1) {
			animation-duration: 1.4s;
		}

		&::before {
			content: "";
			position: absolute;
			background: #222;
			width: $globe-width - 2;
			height: $globe-height / 3;
			border-radius: 3px;
			top: -( $globe-height / 6 );
			left: 1px;
		}

		&::after {
			content: "";
			position: absolute;
			top: -( $globe-height / 2 );
			left: $globe-width - 3;
			width: $globe-spacing + 12;
			height: $globe-height / 3 * 2;
			border-bottom: 2px solid #222;
			border-radius: 50%;
		}

		&:last-child::after {
			content: none;
		}

		&:first-child {
			margin-left: -$globe-spacing;
		}
	}
}

@keyframes flash-1 {
	0%, 100% {
		background: $color-1;
		box-shadow: 0 $globe-height/6 $globe-width*2 $globe-spread $color-1;
	}
	50% {
		background: rgba($color-1, $light-off-opacity);
		box-shadow: 0 $globe-height/6 $globe-width*2 $globe-spread rgba($color-1, 0.2);
	}
}

@keyframes flash-2 {
	0%, 100% {
		background: $color-2;
		box-shadow: 0 $globe-height/6 $globe-width*2 $globe-spread $color-2;
	}
	50% {
		background: rgba($color-2, $light-off-opacity);
		box-shadow: 0 $globe-height/6 $globe-width*2 $globe-spread rgba($color-2, 0.2);
	}
}

@keyframes flash-3 {
	0%, 100% {
		background: $color-3;
		box-shadow: 0 $globe-height/6 $globe-width*2 $globe-spread $color-3;
	}
	50% {
		background: rgba($color-3, $light-off-opacity);
		box-shadow: 0 $globe-height/6 $globe-width*2 $globe-spread rgba($color-3, 0.2);
	}
}
</style>
